import MobileBridge from '@interco/inter-mobile-bridge'

import { TParamsRequest } from './types'

declare global {
  interface Window {
    webkit: {
      messageHandlers: { execute?: { postMessage?: unknown } }
    }
    Android: { execute?: unknown }
  }
}

type BridgeCallable = ((body: unknown) => unknown) & {
  __bridgeCompatibilityStub__?: boolean
}

const isRealBridgeMethod = (method: unknown): method is BridgeCallable =>
  typeof method === 'function' && !(method as BridgeCallable).__bridgeCompatibilityStub__

const hasAndroidExecute = () => isRealBridgeMethod(window.Android?.execute)

const hasIosExecutePostMessage = () =>
  isRealBridgeMethod(window.webkit?.messageHandlers?.execute?.postMessage)

export const isOldBridge = () => !hasAndroidExecute() && !hasIosExecutePostMessage()

export const callByOldBridge = async ({
  headers = { 'Content-Type': 'application/json' },
  pathname,
  method,
  data,
  host,
  engine,
}: TParamsRequest) => {
  const path = `/mobile/${pathname}`
  const response = await MobileBridge.execute({
    headers,
    pathname: path,
    method,
    data,
    host,
    engine: engine || 'CA',
  })
  return response
}
